module.exports = __webpack_public_path__ + "img/05.66e66d74.svg";